"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ShopTitle() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2122" id="shop-title" className="relative bg-background text-foreground py-24 md:py-32 overflow-hidden">
      {}
      <span aria-hidden className="pointer-events-none absolute top-6 left-6 md:top-8 md:left-8 font-mono text-muted-foreground/60 text-xs select-none">
        +
      </span>
      <span aria-hidden className="pointer-events-none absolute top-6 right-6 md:top-8 md:right-8 font-mono text-muted-foreground/60 text-xs select-none">
        +
      </span>
      <span aria-hidden className="pointer-events-none absolute bottom-6 left-6 md:bottom-8 md:left-8 font-mono text-muted-foreground/60 text-xs select-none">
        +
      </span>
      <span aria-hidden className="pointer-events-none absolute bottom-6 right-6 md:bottom-8 md:right-8 font-mono text-muted-foreground/60 text-xs select-none">
        +
      </span>

      <div className="max-w-[1440px] mx-auto px-5 md:px-8 lg:px-16">
        {}
        <div className="lg:hidden mb-8 flex flex-wrap items-center gap-x-6 gap-y-2 font-mono text-[0.72rem] tracking-[0.12em] uppercase text-muted-foreground">
          <span>PRODUCTS · 12</span>
          <span>LAST UPDATE · 24.05.MMXXV</span>
        </div>

        <div ref={ref} className={["grid grid-cols-1 lg:grid-cols-12 gap-y-12 lg:gap-x-6", "transition-all duration-[720ms] ease-[cubic-bezier(0.22,1,0.36,1)]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"].join(" ")}>
          {}
          <div className="lg:col-span-8 flex flex-col">
            {}
            <div className="mb-8 md:mb-10 flex items-center gap-3">
              <span className="font-mono text-[0.72rem] md:text-[0.78rem] font-medium tracking-[0.18em] uppercase text-muted-foreground leading-none">
                § 01 — THE CATALOG / CONSTRUCTION MATERIALS
              </span>
            </div>

            {}
            <h1 className="font-default font-semibold text-foreground" style={{
            fontSize: "clamp(2.75rem, 6.4vw, 5.75rem)",
            letterSpacing: "-0.025em",
            lineHeight: 0.98
          }}>
              Engineering the{" "}
              <em className="not-italic" style={{
              fontStyle: "italic",
              color: "var(--primary)"
            }}>
                future
              </em>
              .
            </h1>

            {}
            <p className="mt-12 font-default text-muted-foreground max-w-[56ch]" style={{
            fontSize: "clamp(1.125rem, 1.4vw, 1.375rem)",
            lineHeight: 1.5
          }}>
              A comprehensive selection of premium construction materials, from high-performance sandwich panels to structural steel systems. Each component is sourced from certified manufacturers to ensure Swiss-grade durability and precision for your most demanding projects.
            </p>
          </div>

          {}
          <div className="hidden lg:flex lg:col-span-4 lg:col-start-9 relative flex-col items-end justify-end pb-2">
            {}
            <div aria-hidden className="absolute -top-4 right-0 w-44 h-44 pointer-events-none opacity-[0.12]" style={{
            animation: "flow-rings-spin 60s linear infinite"
          }}>
              <svg viewBox="0 0 200 200" className="w-full h-full">
                {[20, 35, 50, 65, 80, 92].map((r, i) => <circle key={i} data-index={i} cx="100" cy="100" r={r} fill="none" stroke="currentColor" strokeWidth="1" className="text-foreground" />)}
              </svg>
            </div>

            {}
            <div className="relative z-10 flex flex-col items-end gap-3 font-mono text-[0.72rem] tracking-[0.12em] uppercase text-muted-foreground">
              <span className="leading-none">PRODUCTS · 12</span>
              <span className="leading-none">LAST UPDATE · 24.05.MMXXV</span>
              <span className="leading-none" style={{
              color: "var(--primary)"
            }}>
                DISTRIBUTED IN EUROPE
              </span>
            </div>
          </div>
        </div>

        {}
        <div className="mt-20 md:mt-24 flex items-center w-full">
          <div className="flex-1 h-px bg-foreground/15" />
          <span aria-hidden className="block size-1.5 rounded-lg ml-2" style={{
          backgroundColor: "var(--primary)"
        }} />
        </div>
      </div>

      <style>{`
        @keyframes flow-rings-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @media (prefers-reduced-motion: reduce) {
          [style*="flow-rings-spin"] { animation: none !important; }
        }
      `}</style>
    </section>;
}